export const PDF_TRANSLATIONS = {
    en: {
        applicationId: "Application ID",
        submissionDate: "Submission date",
        organizationName: "Organization Name",
        tin: "Tax Identification Number",
        address: "Address",
        contactDetails: "Contact Details",
        website: "Website",
        social: "Social media",
        legalRep: "Legal Representative",
        contactPerson: "Contact Person",
        confirmation: "Confirmation that applicant is acting on behalf of organization",
        orgInfo: "Organization Information",
        requestDesc: "Request Description",
        amount: "Requested Amount",
        currency: "Currency",
        page: "Page",
        registeredAsPer: "Registered as per",
        dateEstablished: "Date Established",
        fiscalSponsor: "Fiscal Sponsor (if applicable)",
    },
    el: {
        applicationId: "Κωδικός Αιτήματος",
        submissionDate: "Ημερομηνία Υποβολής",
        organizationName: "Όνομα Οργανισμού",
        tin: "ΑΦΜ",
        address: "Διεύθυνση",
        contactDetails: "Στοιχεία Επικοινωνίας",
        website: "Ιστοσελίδα",
        social: "Κοινωνική Δικτύωση",
        legalRep: "Νόμιμος Εκπρόσωπος",
        contactPerson: "Υπεύθυνος Υποβολής Αιτήματος",
        confirmation: "Επιβεβαίωση ότι ο αιτών εκπροσωπεί τον οργανισμό",
        orgInfo: "Περιγραφή Οργανισμού",
        requestDesc: "Περιγραφή Αιτήματος",
        amount: "Αιτούμενο Ποσό",
        currency: "Νόμισμα",
        page: "Σελίδα",
        registeredAsPer: "Εγγεγραμένος Ως",
        dateEstablished: "Ημερομηνία Ίδρυσης",
        fiscalSponsor: "Φορέας Διαχείρισης (αν υπάρχει)",
    },
};
